import styled, { css } from 'styled-components';

export const DetailContainer = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.km4};

    @media screen and (min-width: ${theme.breakpoint.sm.maxWidth}) {
      width: 119px;
    }
  `}
`;

export const WrapperTextOverflowEllipsis = styled.span`
  font: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`;
